module.exports = __webpack_public_path__ + "img/article_3_2.54c642a1.png";